import styled from '@emotion/styled';

import ReactGA from 'react-ga';

import { css } from '@emotion/react';

import COLOR from '../../shared/constant/colorset';

import ScreenOut from '../../shared/components/Pagination/ScreenOut';
import RawHTML from '../../shared/components/layouts/RawHTML';

import { GA_INIT_KEY } from '../../shared/configs/config';

import { amplitudeService } from '../../shared/amplitude';
import { SelectJoinTopBanner } from '../../shared/amplitude/events';

const Wrapper = styled.div<{ visible: boolean; bannerColorType: boolean; isPc: boolean; }>`
  position: relative;
  text-align: center;
  transition: margin .4s linear;
  ${({ isPc }) => isPc && css`
    min-width: 1050px;
    > div {
      position: relative;
      width: 1050px;
      margin: 0 auto;
    }
  `};
  border-bottom: ${({ bannerColorType }) => bannerColorType ? 0 : '1px solid #f4f4f4'};
  background: ${({ bannerColorType }) => bannerColorType ? COLOR.kurlyPurple : COLOR.kurlyWhite};
  ${({ visible, isPc })=> !visible && `margin-top: ${isPc ? '-42px' : '-38px'}`};
`;

const Link = styled.a<{ bannerColorType: boolean; isPc: boolean; }>`
  display: block;
  font-size: 14px;
  line-height: ${({ isPc }) => isPc ? '42px' : '38px'};
  color: ${({ bannerColorType }) => bannerColorType ? COLOR.kurlyWhite : COLOR.kurlyGray800};
  height: ${({ isPc }) => isPc ? '42px' : '38px'};
  > span {
    vertical-align: top;
  }
  b {
    color: ${({ bannerColorType }) => bannerColorType ? COLOR.kurlyWhite : COLOR.kurlyPurple};
  }
`;

const CloseButton = styled.button<{ bannerColorType: boolean; isPc: boolean; }>`
  position: absolute;
  top: 0;
  ${({ isPc }) => isPc ? 'right: 0' : 'left: 0'};
  width: ${({ isPc }) => isPc ? '42px' : '38px'};
  height: ${({ isPc }) => isPc ? '42px' : '38px'};
  background-position: 0 0;
  background-size: ${({ isPc }) => isPc ? '42px 42px' : '38px 38px'};
  background-image: ${({ bannerColorType }) => bannerColorType
    ? 'url(https://res.kurly.com/pc/ico/1908/ico_close_fff_84x84.png)'
    : 'url(https://res.kurly.com/pc/ico/1908/ico_close_333_84x84.png)'};
`;

/*
  기능: 상단띠배너
  로그인전: 신규회원혜택 이벤트url
  로그인후: 친구초대 이벤트url
*/
interface Props {
  visible: boolean;
  loggedIn: boolean;
  title?: string;
  link: string;
  isPc: boolean;
  onClickClose(): void;
  locationTarget: string;
}

export default function TopBanners({
  visible = true,
  loggedIn = false,
  title,
  link,
  isPc,
  onClickClose,
  locationTarget,
}: Props) {
  const handleClickBanner = (url: string) => {
    const gaCode = loggedIn ? 'general_header_friends' : 'general_header_sighup';

    ReactGA.initialize(GA_INIT_KEY);
    ReactGA.ga('send', 'event', 'click', gaCode, window.location.href);

    if (!loggedIn) {
      amplitudeService.logEvent(new SelectJoinTopBanner());
    }

    window.location.assign(url);
  };

  const onClick = () => {
    const expires: number = new Date().setDate(new Date().getDate() + 1);
    localStorage.setItem('top_banner_hide', String(expires));

    onClickClose();
  };

  const purpleType = isPc && !loggedIn;

  return (
    <Wrapper
      visible={visible}
      bannerColorType={purpleType}
      isPc={isPc}
    >
      <div>
        <Link
          href={link}
          bannerColorType={purpleType}
          rel="noreferrer"
          isPc={isPc}
          target={locationTarget === 'NEW' ? '_blank' : '_self'}
          onClick={() => handleClickBanner(link)}
        >
          {title && <RawHTML html={title} />}
        </Link>
        <CloseButton
          bannerColorType={purpleType}
          onClick={onClick}
          type="button"
          isPc={isPc}
        >
          <ScreenOut>배너 하루 안보기</ScreenOut>
        </CloseButton>
      </div>
    </Wrapper>
  );
}
